import dashboardNavbarConst from '@/consts/dashboardNavbar.const.js';

const propertiesRoutes = [
    { 
      path: '/properties',
      name: 'properties',
      component: () => import(/* webpackChunkName: "properties" */ '@/pages/globalEndToEnd/properties/properties.vue'),
      props: true,
      meta: {
        id: dashboardNavbarConst.PROPERTIES,
      },
    },
  ];
  
  export default propertiesRoutes;
  